// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'document-pdf';

export const Component = () => (
  <path d='M22.594 24.521V6.848L15.745 0H2v24.521h20.594Zm-6.85-23.036L21.11 6.85h-5.364V1.485Zm5.892 6.37-.048 15.708H2.958V.958h11.781v6.897h6.897ZM9.854 12.74c0 .623-.191 1.054-.575 1.389a1.919 1.919 0 0 1-1.39.575H6.885v1.963h-.957v-5.89H7.89c.526 0 1.005.191 1.389.575.383.383.575.861.575 1.389v-.001Zm-2.97-.958v1.963H7.89a.946.946 0 0 0 .67-.287.976.976 0 0 0 .288-.719.946.946 0 0 0-.288-.67.946.946 0 0 0-.67-.288H6.884v.001Zm9.818 1.963v2.921h-.957v-5.89h3.4v1.005h-2.443v.958h1.964v1.006h-1.964ZM14.74 12.74v1.963c0 .623-.191 1.054-.575 1.39-.335.382-.814.574-1.389.574h-1.963v-5.89h1.963c.575 0 1.054.191 1.39.575.382.382.574.861.574 1.389v-.001Zm-2.922-.958v3.927h.192c.43 0 .718 0 .91-.047.191 0 .383-.096.575-.24.192-.142.287-.382.287-.718V12.74c0-.432-.096-.72-.335-.814-.239-.096-.814-.144-1.628-.144v-.001Z' />
);

export const viewBox = '0 0 25 25';
